import React from "react";

export function CyberCommunity() {
  // Store the URLs in an array for easier management
  const communityLinks = [
    { name: "GameCommunity College", url: "https://example.com" },
    { name: "SuperSimpleDev (Highly Recommended)", url: "https://example.com" },
    { name: "PW Skills Tech", url: "https://example.com" },
    { name: "SuperSimpleDev", url: "https://example.com" },
    { name: "Bro Code", url: "https://example.com" },
    { name: "FreeCodeCamp", url: "https://example.com" },
    { name: "Thapa Technical (Recommended)", url: "https://example.com" },
    { name: "Anuj Bhaiya (TailWind CSS)", url: "https://example.com" },
    { name: "Apna College (Recommended)", url: "https://example.com" },
    { name: "Ws Cube Tech (TailWind CSS)", url: "https://example.com" },
  ];

  return (
    <>
      <h1 className="html_yt_heading">
        These are the <strong style={{ textDecoration: "underline", color: "blue" }}>Top 5</strong> Game Community Pages That You Can Refer
      </h1>
      
      <h4 className="des_yt_html">
        1. Dive Into The Main Concepts <br />
        2. Animation Explanations with Real World Examples <br />
        3. Important with Note Clarification.
      </h4>

      <h3 style={{ textAlign: "center" }}>Reddit Community Groups</h3>

      {/* Iterate over communityLinks and render each one */}
      {communityLinks.map((link, index) => (
        <div key={index} className="container_html_yt_links">
          <p className="vid">
            {index + 1}. {link.name}
            <button
              style={{
                marginLeft: "200px",
                padding: "7px",
                background: "black",
                color: "white",
                borderRadius: "8px",
              }}
              onClick={() => window.open(link.url, "_blank")}
            >
              Click Me
            </button>
          </p>
        </div>
      ))}

      <h3 style={{ textAlign: "center" }}>Discord Groups</h3>
      {/* Reuse the same communityLinks for discord groups */}
      {communityLinks.map((link, index) => (
        <div key={index} className="container_html_yt_links">
          <p className="vid">
            {index + 1}. {link.name}
            <button
              style={{
                marginLeft: "200px",
                padding: "7px",
                background: "black",
                color: "white",
                borderRadius: "8px",
              }}
              onClick={() => window.open(link.url, "_blank")}
            >
              Click Me
            </button>
          </p>
        </div>
      ))}

      <h3 style={{ textAlign: "center" }}>LinkedIn Groups</h3>
      {/* Reuse the same communityLinks for linkedin groups */}
      {communityLinks.map((link, index) => (
        <div key={index} className="container_html_yt_links">
          <p className="vid">
            {index + 1}. {link.name}
            <button
              style={{
                marginLeft: "200px",
                padding: "7px",
                background: "black",
                color: "white",
                borderRadius: "8px",
              }}
              onClick={() => window.open(link.url, "_blank")}
            >
              Click Me
            </button>
          </p>
        </div>
      ))}
    </>
  );
}

export default CyberCommunity;
